/**
 * The external dependencies.
 */
import React, {forwardRef} from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const BaseButton = forwardRef((
  {
    children,
    className,
    href,
    block,
		loading,
    ...props
  },
  ref
) => {
  return href?.length > 0 ? (
    <a ref={ref} href={href} className={classNames('btn', { 'btn--block': block }, className)} {...props}>
      {children}
    </a>
  ) : (
    <button ref={ref} className={classNames('btn', { 'btn--block': block }, className)} {...props}>
			{loading && <FontAwesomeIcon icon={faCircleNotch} spin className="fast-spin" color="#7e7e7e"/>}
      {!loading && children}
    </button>
  );
});





export default BaseButton;
